export { Header } from './Header';
export { Footer } from './Footer';
export { Content } from './Content';
export { Footnote } from './Footnote';
export { Illustration } from './Illustration';
